import * as React from 'react';

function SvgPencilIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 15" {...props}>
      <path
        stroke="#007BFF"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.2}
        d="M8 14h7M10.333 2.53l2.333 2.293m-1.263-3.348c.31-.304.73-.475 1.168-.475s.858.171 1.167.475c.31.305.484.718.484 1.148s-.174.844-.484 1.148l-9.341 9.185a1.56 1.56 0 0 1-.665.387l-2.234.64a.4.4 0 0 1-.384-.096.38.38 0 0 1-.098-.377l.651-2.197c.074-.246.209-.47.394-.652z"
      />
    </svg>
  );
}
export default SvgPencilIcon;
